import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard {
  constructor(private authService: AuthenticationService) {}

  public canLoad(): boolean | Observable<boolean> {
    if (this.authService.accessToken) {
      return true;
    }

    if (this.authService.refreshToken) {
      return this.authService.acquireTokenSilent().pipe(
        map((response) => {
          return !!response.accessToken;
        }),
        catchError(() => {
          this.authService.loginRedirect();

          return of(false);
        }),
      );
    }

    this.authService.loginRedirect();
    return false;
  }
}
